import { h, render, Component } from 'preact';
import "../scss/main";
import { PasswordForm } from './components/password-form';
import { SecondFactorForm } from './components/second-factor-form';
import {DeviceEnrollmentWizard} from './components/device-enrollment-wizard/device-enrollment-wizard'
import PasswordReset from './routes/password-reset';
import ForgotPassword from './routes/forgot-password';

export class Authenticator extends Component {
  constructor(props) {
    super(props);
    var me = this;

    me.state = {
      recoveryToken: (new URL(window.location)).searchParams.get("recoveryToken") || '',
      loc: window.location.href,
      authStage: ''
    }
  }

  componentDidMount() {
    localStorage.removeItem('timeoutEpoch');
  }

  updateAuthStage = (authStage) => {
    this.setState({authStage: authStage});
  }

  componentDidUpdate() {
    var logoArea = document.getElementsByClassName('logo-area')[0]
    if(this.state.authStage == 'deviceEnrollment') {
      logoArea.classList.add('shrink');
    } else {
      logoArea.classList.remove('shrink');
    }
  }

  render(props, state) {        
    if(state.loc.indexOf('forgot-password') !=-1){
      return <ForgotPassword recoveryToken/>
    }
    if(state.recoveryToken !=""){
      return <PasswordReset recoveryToken/>
    }
    switch (state.authStage) {
      case 'awaitingSecondFactor':
        return <SecondFactorForm />
        break;
    
      case 'deviceEnrollment':
        return <DeviceEnrollmentWizard updateAuthStage={this.updateAuthStage}/>
        break;
        
      default:
        return <PasswordForm updateAuthStage={this.updateAuthStage}/>
        break;
    }
  }
}

render(<Authenticator/>, document.getElementById("form"));
